import React from 'react'

import { EditableImage } from 'features/views/attributes/editable/EditableImage'

import { Avatar } from 'ui/components/Avatar'
import { AvatarStyles } from 'ui/components/Avatar/Avatar.css'
import { Box } from 'ui/components/Box'

import { useDetailViewProfileImageAttributeState } from './hooks/useDetailViewProfileImageAttributeState'

type DetailViewProfileImageAttributeProps = React.ComponentPropsWithoutRef<typeof Avatar> & {}

export const DetailViewProfileImageAttribute: React.FC<DetailViewProfileImageAttributeProps> =
    React.memo(function DetailViewProfileImageAttribute({ size, shape = 'circle', ...props }) {
        const { hasThumbnail, imageSrc, firstName, lastName, profileImageField, allowEditImage } =
            useDetailViewProfileImageAttributeState()
        const avatarType = (!!imageSrc ? 'image' : 'initial') as any

        if (!hasThumbnail) return null

        return (
            <Box
                className={AvatarStyles.styleFunction({ size, shape, type: avatarType })}
                overflow="hidden"
            >
                {allowEditImage && (
                    <EditableImage type="field" field={profileImageField} size={size} />
                )}
                <Avatar
                    size={size}
                    shape={shape}
                    {...props}
                    type={avatarType}
                    imageUrl={imageSrc}
                    firstName={firstName}
                    lastName={lastName}
                />
            </Box>
        )
    })
